import { req } from "@/api/api_request";

// 获取任务类型
export function getTaskType() {
  let url = `task/get-task-type`;
  return req.get(url);
}

// 获取任务列表
export function getTaskList(
  group_id,
  page,
  size,
  station_name,
  task_type_id,
  ops_user_id,
  start_time,
  end_time,
  task_status
) {
  let url = `task/get-list?group_id=${group_id}&start_time=${start_time}&end_time=${end_time}&page=${page}&size=${size}`;
  if (station_name) {
    url += `&station_name=${station_name}`;
  }
  if (task_type_id) {
    url += `&task_type_id=${task_type_id}`;
  }
  if (ops_user_id) {
    url += `&ops_user_id=${ops_user_id}`;
  }
  if (task_status == 0 || task_status == 1) {
    url += `&task_status=${task_status}`;
  }
  return req.get(url);
}

// 添加运维任务
export function addOperationTask(params) {
  let url = `task/add`;
  return req.post(url, params);
}

// 添加运维任务日志
export function addOperationTaskLog(params) {
  let url = `task/add-ops-log`;
  return req.post(url, params);
}

// 获取任务详情（运维信息）
export function getTaskDetails(task_id) {
  let url = `task/get-task-details?task_id=${task_id}`;
  return req.get(url);
}
